
import BestellungFiliale from "@/entities/common/bestellung_filiale"
import Vue from "vue"
import { Component, PropSync } from "vue-property-decorator"

@Component
export default class OeffnungLabel extends Vue {
  @PropSync("filiale") filialeSync?: BestellungFiliale

  heuteGeoeffnet: boolean = false

  mounted() {
    if (!this.filialeSync) return
    if (this.filialeSync.zurZeitGeoeffnet) {
      this.heuteGeoeffnet = true
      return
    }
  }
}
